import { ErrorBoundary } from 'react-error-boundary'
import { AppProviders } from './providers'
import { AppRouter } from './router'
import { AppErrorScreen } from '@/shared/components/AppErrorScreen'

export function App() {
  return (
    <ErrorBoundary
      fallbackRender={({ error, resetErrorBoundary }) => (
        <AppErrorScreen
          error={error}
          fit="page"
          onRetry={resetErrorBoundary}
          onReload={() => globalThis.location.reload()}
        />
      )}
    >
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </ErrorBoundary>
  )
}
